import React from "react";
import { Circles } from "react-loader-spinner";

export const LoaderButton = ({ isLoading, btnName }) => {
  return (
    <>
      <button
        type="submit"
        disabled={isLoading}
        className="mb-2 me-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        {isLoading ? (
          <Circles
            height="20"
            width="80"
            color="#fff"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        ) : (
          btnName
        )}
      </button>
    </>
  );
};
